import { onBeforeUnmount } from 'vue'
import { getRecognitionImage } from '@/api/upload'

// 只处理上传识别产生的 cut_image；预设示例仍直接加载公开静态图片。
export function useRecognitionImages() {
  const objectUrls = new Set()
  let controller = null
  let generation = 0

  const resetRecognitionImages = () => {
    generation += 1
    controller?.abort()
    controller = null
    objectUrls.forEach((url) => URL.revokeObjectURL(url))
    objectUrls.clear()
  }

  const loadRecognitionImages = async (shapes, algorithmId) => {
    resetRecognitionImages()
    const currentGeneration = generation
    controller = new AbortController()
    const { signal } = controller
    try {
      const images = await Promise.all(shapes.map(async (shape) => {
        if (!shape.cut_image) return { ...shape, url: '' }
        const blob = await getRecognitionImage(shape.cut_image, algorithmId, signal)
        if (currentGeneration !== generation) return null
        const url = URL.createObjectURL(blob)
        objectUrls.add(url)
        return { ...shape, url }
      }))
      return currentGeneration === generation ? images : null
    } catch (error) {
      // 切换预设、重新上传或退出页面时忽略旧请求结果。
      if (currentGeneration !== generation) return null
      resetRecognitionImages()
      throw error
    }
  }

  onBeforeUnmount(resetRecognitionImages)
  return { loadRecognitionImages, resetRecognitionImages }
}